import { useEffect, Fragment } from "react";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Checkbox as RadioBtn } from "@unified-checkout/design-system";
import { Checkbox } from "@unified-checkout/design-system";

import {
  useCheckoutCustomizationStore
} from "@app/dashboard/store/checkout-customization";
import { Title } from "../../../../components/Title";
import styles from "./payment-methods-layout.module.scss";

type TOption = { label: string, value: 'tab' | 'list' };

export const PaymentMethodsLayout = ({
  groupPayLater,
  setGroupPayLater,
  listingType,
  setListingType,
}: {
  groupPayLater: boolean,
  setGroupPayLater: Dispatch<SetStateAction<boolean>>
  listingType: TOption | undefined,
  setListingType: Dispatch<SetStateAction<TOption | undefined>>
}) => {
  const { t } = useTranslation();

  const {
    isFetched,
    isDataReset,
    customizationData,
    setCustomizationData
  } = useCheckoutCustomizationStore();

  const { payments } = customizationData;
  const { pay_later, layout } = payments;

  const layoutOptions: TOption[] = t('innerLayout.checkoutCustomizationPage.tabs.payment.sections.layout.options', { returnObjects: true });

  useEffect(() => {
    if (isFetched) {
      setListingType(layoutOptions.find(opt => opt.value === layout) || layoutOptions[0]);
      setGroupPayLater(pay_later);
    }
  }, [isFetched, isDataReset]);

  const handleLayoutChange = (option: TOption) => {
    setListingType(option);

    setCustomizationData(prevData => ({
      ...prevData,
      payments: {
        ...prevData.payments,
        layout: option.value
      }
    }))
  };

  const handleGroupPayLater = (checked: boolean) => {
    setGroupPayLater(checked);

    setCustomizationData(prevData => ({
      ...prevData,
      payments: {
        ...prevData.payments,
        pay_later: checked
      }
    }))
  };

  return (
    <div className={styles["payment-methods-layout"]}>
      <Title label={t('innerLayout.checkoutCustomizationPage.tabs.payment.sections.layout.label')} />

      {
        layoutOptions.map((option, index) =>
          <Fragment key={`payment-methods-layout-option-${index}`}>
            <RadioBtn
              id={`payment-methods-layout-radio-btn-${index}`}
              type="radio"
              hintText={option.label}
              selected={listingType?.value === option.value}
              onClickHandler={() => handleLayoutChange(option)}
            />

            {
              listingType?.value === 'list' &&
              option.value === 'list' &&
              <div className={styles["payment-methods-layout__group-pl"]}>
                <Checkbox
                  id={`payment-methods-layout-chb-${index}`}
                  type="checkbox"
                  hintText={t('innerLayout.checkoutCustomizationPage.tabs.payment.sections.layout.groupPayLater')}
                  checked={groupPayLater}
                  onClickHandler={(checked) => handleGroupPayLater(checked)}
                />
              </div>
            }
          </Fragment>
        )
      }
    </div>

  )
}
